var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-banner pl-2 pr-2"},[_c('v-avatar',{attrs:{"size":"280px"}},[_c('img',{attrs:{"src":"https://ih0.redbubble.net/image.129280177.0023/flat,800x800,075,f.u1.jpg","alt":"Pasmo"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484ad2ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my-left-component/ProfilePicture.vue
// module id = null
// module chunks = 